import React from 'react';
export function Insignia({
  children,
  tono = 'neutro'
}: {
  children: React.ReactNode;
  tono?: 'neutro' | 'vino' | 'verde' | 'oro' | 'alerta' | 'azul' | 'violeta';
}) {
  const tonos: Record<string, string> = {
    neutro: 'bg-lienzo text-tinta-sec border-linea',
    vino: 'bg-vino/5 text-vino border-vino/20',
    verde: 'bg-[#DCFCE7] text-[#16A34A] border-[#22C55E]/30',
    oro: 'bg-[#FEF9C3] text-[#EAB308] border-[#EAB308]/40',
    alerta: 'bg-alerta/5 text-alerta border-alerta/30',
    azul: 'bg-[#DBEAFE] text-[#1D4ED8] border-[#3B82F6]/30',
    violeta: 'bg-[#F3E8FF] text-[#7E22CE] border-[#A855F7]/30'
  };
  return <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold ${tonos[tono]}`} data-id="element-418" data-mp="241cvvdkgdjva">
      {children}
    </span>;
}
export function Chip({
  activo,
  onClick,
  children
}: {
  activo: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return <button type="button" aria-pressed={activo} onClick={onClick} className={`inline-flex min-h-[44px] items-center gap-1.5 rounded-xl border px-3 text-sm font-semibold transition-colors ${activo ? 'border-vino bg-vino text-white' : 'border-linea bg-white text-tinta-sec hover:border-vino/40 hover:text-vino'}`} data-id="element-419" data-mp="4qllmio1mpg4">
      {children}
    </button>;
}